import { render, staticRenderFns } from "./PrivilegeClub.vue?vue&type=template&id=4cbb5584&scoped=true"
import script from "./PrivilegeClub.vue?vue&type=script&lang=js"
export * from "./PrivilegeClub.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeClub.vue?vue&type=style&index=0&id=4cbb5584&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb5584",
  null
  
)

export default component.exports